///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-visit-note-type.collection.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportVisitNoteType extends DataTemplateBase implements IDataTemplate {

        protected visitNoteType: ReportVisitNoteTypeCollection;

        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public title: string;

        get collection(): SmartMoverCollectionBase<any> {
            return this.visitNoteType;
        }

        constructor(model: Dictionary<any>, properties: string[], options) {
            super(model, properties, options.criteria);

            this.title = 'HEADER_VISIT_NOTE_TYPES';
            this.allSelectedLabel = 'LABEL_ALL_VISIT_NOTE_TYPES';
            this.totalSelectedMessage = 'LABEL_TOTAL_VISIT_NOTE_TYPES';

            this.filters = [new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_VISIT_NOTE_TYPES'})];

            this.visitNoteType = new ReportVisitNoteTypeCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: (options.defaultValue || {})[properties[1]],
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.visitNoteType.addFilters(...this.filters as IInteractiveFilter[])
        }

        onHideToggle(hidden: boolean): void {
            this.smartMoverHidden = hidden;

            if (!this.smartMoverHidden) {
                this.visitNoteType.resetCollection(this.getSelectedIdsFromModelList());
            }
        }

        getSelectedIdsFromModelList(): string[] {
            var array = [];
            if (this.visitNoteType != null && this.visitNoteType.allModelsList != null) {
                this.visitNoteType.allModelsList.forEach((model, index) => {
                    array.push(model.id);
                });
            }
            return array;
        }
    }
}